import React, { Component } from 'react';
import { radius, typography } from '../config/designTokens';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false,
      error: null,
      errorInfo: null
    };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    this.setState({
      error: error,
      errorInfo: errorInfo
    });
    
    console.error('Error caught by ErrorBoundary:', error, errorInfo);
    
    // Log to an error tracking service if available
    // if (window.errorTrackingService) {
    //   window.errorTrackingService.captureException(error, { extra: errorInfo });
    // }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="min-h-[300px] flex items-center justify-center p-6" dir="rtl">
          <div className={`max-w-md w-full bg-white ${radius.xl} shadow-lg p-6 text-center`}>
            <div className="text-red-600 text-5xl mb-4">⚠️</div>
            <h2 className={`${typography.fontSize.h3.desktop} ${typography.fontWeight.bold} text-gray-800 mb-4`}>
              אירעה שגיאה
            </h2>
            <p className="text-gray-600 mb-6">
              מצטערים, אירעה שגיאה בטעינת התוכן. אנא נסה לרענן את הדף.
            </p>
            <button
              onClick={() => window.location.reload()}
              className={`px-4 py-2 bg-teal-600 hover:bg-teal-700 text-white ${radius.md} transition-colors`}
            >
              רענן דף
            </button>
            
            {process.env.NODE_ENV === 'development' && this.state.error && (
              <div className="mt-6 text-left border-t border-gray-200 pt-4">
                <details className="text-xs">
                  <summary className="text-red-600 cursor-pointer mb-2">פרטי שגיאה למפתחים</summary>
                  <pre className="bg-gray-100 p-2 rounded overflow-auto max-h-[200px]">
                    {this.state.error.toString()}
                    <br />
                    {this.state.errorInfo?.componentStack}
                  </pre>
                </details>
              </div>
            )}
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary; 